module.exports = __webpack_public_path__ + "img/bar-2.a91492a2.png";